<script setup lang="ts">
import BaseTitle from '@/js/account/components/base/BaseTitle.vue';
import LibraryDocumentsBrowse from '@/js/account/components/library/LibraryDocumentsBrowse.vue';
import ProfileHeader from '@/js/account/components/profile/ProfileHeader.vue';
import { useDocumentListBrowse } from '@/js/account/entities/document';
import { accountDocumentsDownloadsIndex } from '@/js/account/entities/document/api';
import { classNames } from '@/js/lib/bem';

const cn = classNames('profile-downloads-page');

const {
  search,
  sortBy,
  filters,
  page,
  loading,
  list,
  error,
  perPage,
  onPageChange,
  reloadFromFirstPage,
  reload,
} = useDocumentListBrowse(accountDocumentsDownloadsIndex);
</script>

<template>
  <div :class="cn()">
    <ProfileHeader>
      <template #left>
        <BaseTitle size="md">
          Download History
        </BaseTitle>
      </template>
    </ProfileHeader>

    <div :class="cn('content')">
      <LibraryDocumentsBrowse
        v-model:search="search"
        v-model:sort-by="sortBy"
        v-model:filters="filters"
        v-model:page="page"
        :list="list"
        :loading="loading"
        :error="error"
        :per-page="perPage"
        empty-message="You have not downloaded any documents yet."
        @reload-from-first-page="reloadFromFirstPage"
        @page-change="onPageChange"
        @reload="reload"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.profile-downloads-page {
  font-family: var(--font-family-sans);
  color: var(--color-text-primary);

  &__content {
    padding: 32px;
  }

  @media (max-width: 768px) {
    &__content {
      padding: 16px;
    }
  }
}
</style>
